import { getCourtVisual } from "@/lib/courtVisualConfig";

/**
 * <CourtLabel raw="TRF6" />
 *   → sigla sempre presente em negrito, na cor determinística do tribunal.
 *
 * Uso consistente em todo o HERMES: DJEN, Preparados, Prazos, Processos, etc.
 * A cor NÃO é a única diferenciação — a sigla textual (bold) e o tooltip
 * garantem acessibilidade AA.
 *
 * Props:
 *   raw:    string livre vinda do backend ("TRF6", "trt-3", "TJMG").
 *   size:   "xs" | "sm" | "md" (default "sm").
 *   variant: "text" (só texto) | "chip" (com background sutil).
 *   className: passthrough.
 *   title:   override do tooltip (padrão = fullName oficial).
 */
export function CourtLabel({ raw, size = "sm", variant = "text",
                              className = "", title, ...rest }) {
  const { code, color, label, fullName } = getCourtVisual(raw);
  const sizeCls = size === "xs" ? "text-[11px]"
                : size === "md" ? "text-sm"
                : "text-xs";
  const tooltip = title || fullName || label;
  if (variant === "chip") {
    return (
      <span
        {...rest}
        title={tooltip}
        data-testid={`court-label-${code}`}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md font-bold uppercase tracking-wide ${sizeCls} ${className}`}
        style={{ color, backgroundColor: `${color}14`, borderColor: `${color}33`, borderWidth: 1 }}
      >
        {label}
      </span>
    );
  }
  return (
    <span
      {...rest}
      title={tooltip}
      data-testid={`court-label-${code}`}
      className={`font-bold uppercase tracking-wide ${sizeCls} ${className}`}
      style={{ color }}
    >
      {label}
    </span>
  );
}

export default CourtLabel;
